import { Injectable } from '@angular/core';
import { buttonsFirst, buttons, buttonsLast } from '../botones';

@Injectable({ providedIn: 'root' })
export class StepsSellosDeTiempoConsultar {
  constructor() {
    this.crear();
  }

  crear() {
    return [
      {
        attachTo: {
          element: '.step_100',
          on: 'bottom' as const,
        },
        title: 'CONSULTAR SELLOS DE TIEMPO',
        text: `
                    En esta página puede consultar todos los sellos de tiempo que ha solicitado y ver sus detalles.
                `,
        buttons: buttonsFirst,
      },
      {
        attachTo: {
          element: '.step_200',
          on: 'bottom' as const,
        },
        title: 'NUEVO SELLO DE TIEMPO',
        text: `
                    Puede acceder directamente a la creación de un nuevo sello: <b>WEB</b> para certificar páginas web, <b>FICHERO</b> para documentos locales.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_300',
          on: 'bottom' as const,
        },
        title: 'COLUMNAS A MOSTRAR',
        text: `
                    Puede seleccionar las columnas que se mostrarán en el listado según sus prioridades.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_400',
          on: 'bottom' as const,
        },
        title: 'MENÚ DE ACCIONES',
        text: `
                    Desde el menú <b>⋮</b> puede <b>exportar</b> los registros en formato CSV (compatible con Excel, Google Sheets, LibreOffice...) y <b>limpiar los filtros</b> activos.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_600',
          on: 'bottom' as const,
        },
        title: 'COLUMNAS',
        text: `
                    Al pulsar sobre cada columna se ordenarán los registros de forma ascendente o descendente.  También puede reordenar las columnas arrastrándolas a la posición deseada manteniendo pulsado el botón del ratón.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.step_700',
          on: 'bottom' as const,
        },
        title: 'FILTROS',
        text: `
                    Puede filtrar los registros por columnas introduciendo valores en estas casillas.
                `,
        buttons: buttons,
      },

      {
        attachTo: {
          element: '.p-datatable-tbody',
          on: 'bottom' as const,
        },
        title: 'DATOS',
        text: `
                    En la parte central de la tabla tendrá acceso a los registros.  En la última columna se muestran las acciones que puede realizar sobre cada registro.
                `,
        buttons: buttons,
      },
      {
        attachTo: {
          element: '.p-paginator',
          on: 'bottom' as const,
        },
        title: 'PAGINADOR',
        text: `
                    Puede cambiar de página utilizando el paginador y el número de registros mostrados en cada página.
                `,
        buttons: buttonsLast,
      },
    ];
  }
}
